
export default [
  {
    url: "/partner/",
    name: "Home",
    slug: "home",
    icon: "HomeIcon",
    //permission : 'stats.read',
  },
  {
    name: "Trips",
    slug: "trips",
    icon: "MapIcon",
    permission : 'trips',
    submenu: [
      {
        url: '/partner/trips/list',
        name: 'List',
        slug: 'trips-list',
        permission : 'trips.read',
      },
      {
        url: '/partner/trips/add',
        name: 'Add',
        slug: 'trips-add',
        permission : 'trips.create',
      },
      
      {
        url: '/partner/trips/monitor',
        name: 'Monitor',
        slug: 'trips-monitor',
        permission : 'partner.trips.monitor',
      },
      
    ]
  },

  {
    name: "Vehicles",
    slug: "vehicles",
    icon: "TruckIcon",
    permission : 'vehicles',
    submenu: [
      {
        url: '/partner/vehicles/list',
        name: 'List',
        slug: 'vehicles-list',
        permission : 'vehicles.read',
      },
      {
        url: '/partner/vehicles/add',
        name: 'Add',
        slug: 'vehicles-add',
        permission : 'vehicles.create',
      }
    ]
  },
  {
    name: "Drivers",
    slug: "drivers",
    icon: "ListIcon",
    permission : 'drivers',
    submenu: [
      {
        url: '/partner/drivers/list',
        name: 'List',
        slug: 'driver-list',
        permission : 'drivers.read',
      },
      {
        url: '/partner/drivers/add',
        name: 'Add',
        slug: 'driver-add',
        permission : 'drivers.create',
      }
    ]
  },
  {
    name: "Users",
    slug: "users",
    url: '/partner/users',
    icon: "UsersIcon",
    permission : 'capacity_control_user.read',
  },
  {
    name: "Reports",
    slug: "reports",
    icon: "FileTextIcon",
    submenu: [
      
      {
        url: '/partner/reports/routes',
        name: 'Routes',
        slug: 'report.routes',
      },
      {
        url: '/partner/reports/trips',
        name: 'Trips',
        slug: 'report.trips',
      },
      {
        url: '/partner/reports/drivers',
        name: 'Drivers',
        slug: 'report.driver',
      },
      {
        url: '/partner/reports/codes',
        name: 'Checkings',
        slug: 'report.codes',
      },
      {
        url: '/partner/reports/passengers',
        name: 'Passengers',
        slug: 'report.passengers',
      }
    ]
  },
]
